import { createFileRoute, redirect } from "@tanstack/react-router";

// Brooklyn schedule page removed — permanently redirect to the main schedule page.
export const Route = createFileRoute("/schedule-a-consult/brooklyn")({
  beforeLoad: () => {
    throw redirect({
      href: "/schedule-a-consult/",
      statusCode: 301,
    });
  },
});
